import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'

export const useHealthEventTracker = () => {
  const tracker = useTracker()

  const trackClickPlayAppDownload = () => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickPlayAppDownload)
  }

  return {
    trackClickPlayAppDownload,
  }
}
